<template>
  <PVMessage
    :severity="severity"
    :size="size"
    :variant="variant"
    :closable="closable"
    :pt="messagePt"
  >
    <slot />
  </PVMessage>
</template>

<script lang="ts">
export default {
  name: 'StandardMessage',
  compatConfig: { MODE: 3 },
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { computed, useAttrs, type CSSProperties } from 'vue';
import type { MessageProps } from 'primevue/message';

const props = withDefaults(
  defineProps<{
    /**
     * Visual style from the active design-token preset.
     * `error` replaces Bootstrap `danger`; `warn` replaces `warning`.
     */
    severity?: MessageProps['severity'];
    /**
     * Message size. Omit for the default alert size.
     * Invalid feedback uses `small`.
     */
    size?: MessageProps['size'];
    /**
     * Message variant. Omit for the default filled alert.
     * Invalid feedback uses `simple`.
     */
    variant?: MessageProps['variant'];
    /**
     * Shows a close icon when true. Alerts stay open unless a page asks to dismiss them.
     */
    closable?: boolean;
    textStyle?: CSSProperties;
  }>(),
  {
    severity: 'info',
    closable: false,
  },
);

const attrs = useAttrs();

/**
 * Message sets inheritAttrs false and does not place $attrs on its root.
 * Call sites still pass class and style the way b-alert did.
 */
const messagePt = computed((): MessageProps['pt'] => ({
  root: attrs,
  text: {
    style: props.textStyle ?? {},
  },
}));
</script>
